class InternetComPremiereCombateController {

  constructor(mainClassName) {
    this.mainClassName = mainClassName
    this.carrousel = new CardsCarrousel('cardsPremiereCombate')
    this.dotsContainerElement = document.getElementById('dotsPremiereCombateCards')
    this.renderDots()
    this.deployListeners()
    this.setDotActiveByIndex(0)

  }

  renderDots() {
    const { dotsAmount } = this.carrousel.properties;
    this.dotsContainerElement.innerHTML = ''

    for (let dotIndex = 0; dotIndex < dotsAmount; dotIndex++) {
      const dotBtnElement = document.createElement('button')
      dotBtnElement.setAttribute('aria-label', 'Mudança de Card')

      

      dotBtnElement.className = this.concatClasses('dots', 'child')

      dotBtnElement.addEventListener('click', () => {
        this.carrousel.setCurrentPositionByIndex(dotIndex)
        this.carrousel.properties.currentDotIndex
      });

      this.dotsContainerElement.appendChild(dotBtnElement);

    }
  }

  deployListeners() {
    this.carrousel.on('resize', (e) => {
      this.setDotActiveByIndex(e.currentDotIndex)
      this.renderDots()
    })
    this.carrousel.on('scroll', (e) => {
      this.setDotActiveByIndex(e.currentDotIndex)
    })
    this.carrousel.on('changecards', (e) => {
      this.setDotActiveByIndex(e.currentDotIndex)
    })
  }
  setDotActiveByIndex(index) {
    [...this.dotsContainerElement.children].forEach((child, i) =>
      child.classList[index == i ? 'add' : 'remove'](
        this.concatClasses('dots', 'child', 'active')
      ))
  }

  concatClasses(/** @type {string[]} */ ...classes) {
    return [this.mainClassName, ...classes].join('__')
  }
}


try {
  new InternetComPremiereCombateController('internet-com-premiere-combate-dots')
} catch (error) {
  console.log('erro ao instanciar carrossel', error)
}

const BOX_TITLE_PREMIERE_COMBATE_ELEMENT = document.getElementById('boxTitlePremiereCombate')
const CONTAINER_PREMIERE_COMBATE_ELEMENT = document.getElementById('containerPremiereCombate')
const MAIN_CONTAINER_PREMIERE_COMBAT_ELEMENT = document.getElementById('mainContainerPremiereCombate')

const maxWidthToggle = () => {
  const windowSize = window.innerWidth

  if (!CONTAINER_PREMIERE_COMBATE_ELEMENT && !MAIN_CONTAINER_PREMIERE_COMBAT_ELEMENT){
    return
  }

  if (windowSize < 768){
    BOX_TITLE_PREMIERE_COMBATE_ELEMENT.classList.add('max-width')
    CONTAINER_PREMIERE_COMBATE_ELEMENT.classList.remove('max-width')
    MAIN_CONTAINER_PREMIERE_COMBAT_ELEMENT.classList.remove('max-width')


  } else {
    BOX_TITLE_PREMIERE_COMBATE_ELEMENT.classList.remove('max-width')
    CONTAINER_PREMIERE_COMBATE_ELEMENT.classList.add('max-width')
    MAIN_CONTAINER_PREMIERE_COMBAT_ELEMENT.classList.add('max-width')


  }
}

maxWidthToggle()

window.addEventListener('resize', () => {
  maxWidthToggle()
})
